<app-facility-logo [width]="'153'" [height]="'60'"></app-facility-logo>
<h3 class="mat-headline-4 primary-text fw-bold mb-3">Dear Valued Customer,</h3>
<app-redirection-by-arrived-day [redirectionUrl]="urlPolar" [arrivedDay]="arrivedDay"></app-redirection-by-arrived-day>
<div class="d-flex justify-content-end mt-3 flex-wrap">
    <div class="d-flex align-items-end">
        <button
            id="message-continue-button"
            mat-flat-button
            color="primary"
            target="_blank"
            class="me-3"
            (click)="closeDialog()"
        >
            CONTINUE
        </button>
    </div>
</div>
